import { groq } from "hydrogen-sanity/groq";
import { BASE_LINK, ICONS, IMAGE, LINK } from "./components";

const TESTIMONIAL = groq`
    ${IMAGE},
    cardCallout{
        ...,
        links[]{
            ${BASE_LINK}
        }
    }
`;
const BLOCKTEXTCOLUMNS = groq`
    links[]{
        ${BASE_LINK}
    }
`;
const GRIDTWOCOLUMNS = groq`
    cards[]{
        ... {
            ...,
            ${LINK},
            ${IMAGE}
            }
        }
`;
const TEXTMEDIA = groq`
    ${IMAGE},
    links[]{
        ${BASE_LINK}
    }
`;

export const SECTIONS = groq`    
    defined(sectionBlockCallout) => {
        sectionBlockCallout {
            ...,
        }
    },

    defined(sectionBlockFeaturedResearch) => {
        sectionBlockFeaturedResearch {
            title,
            description,
            ${LINK}
        }
    },

    defined(featuredImage) => {
       featuredImage {

        asset -> {
            ...
        }
        }
    },
    defined(testimonial) => {
        testimonial -> {
            ...,
            ${TESTIMONIAL}
        }
    },
    defined(testimonial1) => {
        testimonial1 -> {
            ...,
            ${TESTIMONIAL}
        }
    },
    defined(testimonial2) => {
        testimonial2 -> {
            ...,
            ${TESTIMONIAL}
        }
    },

    defined(callToAction) => {
        callToAction -> {
            ...,
            ${IMAGE},
            links[]{
                ${BASE_LINK}
            }
        }
    },

    defined(callToActionDonation) => {
        callToActionDonation -> {
            ...,
            ${IMAGE},
            links[]{
                ${BASE_LINK}
            }
        }
    },

    defined(blocksCTAInline) => {
        blocksCTAInline[]{
            ... {
                ...,
                ${LINK},
                ${IMAGE}
            }
        },
    },

    defined(cardGrid) => {
        cardGrid[]{
            ... {
                ...,
                ${LINK}
            }
        },
    },

    defined(teams) => {
        teams[] -> {
            ${IMAGE},
            title,
            slug,
            shortTitle,
            _type
        }
    },

    defined(sectionBlockStats) => {
        sectionBlockStats
    },

    defined(sectionBlockStatsAlt) => {
        sectionBlockStatsAlt {
            items[] -> {
                title,
                text
            }
        }
    },

    defined(sectionGridTwoColumns) => {
        sectionGridTwoColumns {
        ...,
${GRIDTWOCOLUMNS},
        }
    },

    defined(sectionBlockTextColumns) => {
        sectionBlockTextColumns {
            ...,
            ${BLOCKTEXTCOLUMNS}
        }
    },

    defined(blockMediaCalloutCard) => {
        blockMediaCalloutCard {
            ...,
             ${IMAGE},
            cardCallout{
                ...,
                links[]{
                    ${BASE_LINK}
                },
                ${IMAGE}
            }
        }
    },

    defined(sectionBlockAccordionContent) => {
        sectionBlockAccordionContent {
            ...,
            ${LINK},
            accordion[] {
                question -> {
                    ...,
                    links[]{
                        ${BASE_LINK}
                    }
                },
                item {
                    ...,
                    links[]{
                        ${BASE_LINK}
                    }
                }
            }
        }
    },

    defined(accordion) => {
        accordion[] {
            question -> {
                ...,
                links[]{
                    ${BASE_LINK}
                }
            },
            item {
                ...,
                links[]{
                    ${BASE_LINK}
                }
            }
        }
    },

    defined(sectionCardCarousel) => {
        sectionCardCarousel {
            ...,
            ${LINK},
            items[]{
                ...,
                ${LINK}
            }
        }
    },

    defined(sectionMarqueeMedia) => {
        sectionMarqueeMedia {
            ...,
            ${LINK},
            media[] -> {
                ...,
                ${IMAGE}
            }
        }
    },

    defined(sectionBlockPinnedMediaItems)=>{
        sectionBlockPinnedMediaItems {
            ...,
            ${IMAGE},
            items[]{
                ...,
                ${IMAGE},
                cardCallout{
                    ...,
                    links[]{
                        ${BASE_LINK}
                    }
                }
            }
        }
    },

    defined(sectionBlockMediaItem)=>{
        sectionBlockMediaItem {
            ...,
            ${IMAGE},
            links[]{
                ${BASE_LINK}
            }
        }
    },

    defined(sectionBlockCardCarousel)=>{
        sectionBlockCardCarousel {
            ...,
            ${LINK},
            items[]{
                ...,
                ${LINK}
            }
        }
    },

    defined(sectionBlockTextMedia)=>{
        sectionBlockPinnedMediaItems {
            ...,
            ${TEXTMEDIA}
        }
    },

    
    defined(sectionGridThreeCards) =>{
        sectionGridThreeCards {
        ...,
        ${LINK},
        cards[]{
            ...,
            ${LINK},
            ${IMAGE},
            ${ICONS}
        }
    }
    },

    defined(sectionForm) =>{
        sectionForm {
            ...,
        }
    },

    defined(sectionNews) =>{
        sectionNews -> {
            slug,
            _type,
        }
    },

    defined(sectionEvents) =>{
        sectionEvents -> {
            slug,
            _type,
        }
    },

    defined(teamArchive) =>{
        teamArchive -> {
            slug,
            title,
        }
    },

    defined(teamCarousel) =>{
        teamCarousel {
            ...,
            team -> {
                slug,
                title
            },
            description
        }
    },

    defined(sectionBlockMap)=>{
        sectionBlockMap {
          ...,
          ${LINK},
          locations[] -> {
           ...,
           partners[]->{
            ...,
            ${IMAGE}
           }
          }
        }
    },

    defined(flexibleComponents)=>{
        flexibleComponents[]{
            ...,
        // Section Block Text Columns
        _type == "sectionBlockTextColumns" => {
                ...,
                ${BLOCKTEXTCOLUMNS}
            },
           
        // Section Block Video
        _type == "sectionBlockVideo" => {
                ...,
            },
        // Section Block
        _type == "sectionBlockTextMedia" => {
                ...,
                ${TEXTMEDIA}
            },

        // Section Quote
        _type == "blockQuote" => {
                ...,
        },

        // Testimonial
            _type == "testimonial" => @->{
                ...,
                ${TESTIMONIAL}
            },

        // Section Grid Two Columns
             _type == "sectionGridTwoColumns" => {
                ...,
                ${GRIDTWOCOLUMNS}
            },

                     // Section Block Text
         _type == "blockText" => {
                ...,
            }
        }        
    }
`;
